import React from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const SelectJobMiniPagination = ({
  current,
  total,
  onChange,
}) => {
  // only 5 page buttons visible
  const getPages = () => {
    const visible = 5;

    let start = Math.max(
      1,
      current - Math.floor(visible / 2)
    );

    let end = start + visible - 1;

    if (end > total) {
      end = total;
      start = Math.max(1, end - visible + 1);
    }

    const pages = [];

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const pages = getPages();

  return (
    <div className="sjm-pagination">
      {/* PREV */}
      <button
        className="sjm-pg-btn sjm-pg-arrow"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
      >
        <LeftOutlined />
      </button>

      {/* FIRST PAGE */}
      {pages[0] > 1 && (
        <>
          <button
            className="sjm-pg-btn"
            onClick={() => onChange(1)}
          >
            1
          </button>

          {pages[0] > 2 && (
            <span className="sjm-pg-dots">
              ...
            </span>
          )}
        </>
      )}

      {/* MIDDLE PAGES */}
      {pages.map((page) => (
        <button
          key={page}
          className={`sjm-pg-btn ${
            current === page
              ? "sjm-pg-active"
              : ""
          }`}
          onClick={() => onChange(page)}
        >
          {page}
        </button>
      ))}

      {/* LAST PAGE */}
      {pages[pages.length - 1] < total && (
        <>
          {pages[pages.length - 1] <
            total - 1 && (
            <span className="sjm-pg-dots">
              ...
            </span>
          )}

          <button
            className="sjm-pg-btn"
            onClick={() => onChange(total)}
          >
            {total}
          </button>
        </>
      )}

      {/* NEXT */}
      <button
        className="sjm-pg-btn sjm-pg-arrow"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
      >
        <RightOutlined />
      </button>
    </div>
  );
};

export default SelectJobMiniPagination;